export default __webpack_public_path__ + "aeacf121047d926a12aa1caf73c100b6.png";